import { Toggle } from 'rsuite';
import { useState } from 'react';
import styles from './SettingToggle.module.scss';
import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';

interface Props {
  id: string;
  title: string;
  description: string;
  checked: boolean;
  loading?: boolean;
  onChange: (key: string, value: boolean) => Promise<boolean>;
}

export const SettingToggle = ({
  id,
  title,
  description,
  checked,
  loading,
  onChange
}: Props) => {
  const [active, setActive] = useState<boolean>(checked);
  const [isLoading, setIsLoading] = useState<boolean>(loading || false);

  const toggle = async (newValue: boolean) => {
    setIsLoading(true);
    setActive(await onChange(id, newValue));
    setIsLoading(false);
  }
  return (
    <div className={styles.container} key={id} id={id}>
      <div className={styles.info}>
        <TextComponent variant="headerMedium">{title}</TextComponent>
        <TextComponent variant="bodySmall">{description}</TextComponent>
      </div>
      <Toggle
        className={styles.toggle}
        loading={isLoading}
        checked={active}
        onChange={toggle}
      />
    </div>
  );
}
